export default __webpack_public_path__ + "static/media/924.63fcfc4a.gif";